const pms_intended_occupancy_status_cc = [
  {
    value: "primary_residence",
    name: "Primary Residence",
  },
  {
    value: "second_home",
    name: "Second Home",
  },
  {
    value: "investment_property",
    name: "Investment Property",
  },
];

export default pms_intended_occupancy_status_cc;



// WEBPACK FOOTER //
// ./src/constants/pms_intended_occupancy_status_cc.js